import React, { useState } from 'react';

import { LayoutOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';
import PreviewRequirementsModal from 'common/components/preview-requirements/PreviewRequirementsModal';
import PreviewRequirementsModalProduct from 'common/components/preview-requirements/PreviewRequirementsModalProduct';

import messages from 'i18n/messages/home';

const MinimumRequirementsValidate = (props) => {
  const { size = 'small', entity, disable } = props;

  const [modalVisible, setModalVisible] = useState(false);

  const onClickButton = () => {
    openMinimumRequirementModal();
  };

  const openMinimumRequirementModal = () => {
    setModalVisible(true);
  };

  const disabled = !entity || disable;
  const isProductEntity = entity?.type?.toLowerCase() === 'product';

  return (
    <>
      <RibbonButton
        size={size}
        className='button-item-dropdown'
        icon={<LayoutOutlined />}
        label={messages.previewRequirements}
        onClick={onClickButton}
        disabled={disabled}
      />
      {modalVisible ? (
        isProductEntity ? (
          <PreviewRequirementsModalProduct
            entity={entity}
            entityType={entity.type}
            visible={modalVisible}
            setVisible={setModalVisible}
          />
        ) : (
          <PreviewRequirementsModal
            entity={entity}
            entityType={entity.type}
            visible={modalVisible}
            setVisible={setModalVisible}
          />
        )
      ) : null}
    </>
  );
};

export default MinimumRequirementsValidate;
